import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function EngleskiJezik2() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Engleski jezik 2" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Engleski jezik 2</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Engleski jezik II
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> Engleski jezik I
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Ciljevi nastave višeg engleskog jezika predmeta Engleski jezik
                II podrazumijeva razvijanje svih elemenata strukture stranog
                jezika na visokom nivou komunikativnih sposobnosti sa akcentom
                na jeziku struke. Težište nastave na II godini je uz neophodno
                aktiviranje motivacije razvijanje automatizacije
                akustičko-motornih obrazaca jezičke građe i istovremeno
                razvijanje sve četiri jezičke vještine: čitanja razumijevanja
                pisanja i govora. U cilju sticanja visokog nivoa komunikativne
                kompetencije nastava se zasniva na stečenim usvojenim modelima
                što podrazumijeva podizanje na visoki nivo kulture komuniciranja
                razvijenim jezičkim obrascima. Nastava je koncipirana na
                razvijanju sposobnosti usvajanja terminologije iz oblasti prava.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Izučavanjem i polaganjem ovog predmeta student će: nadograditi
                gramatičku strukturu, obogatiti i uvećati svoj vokabular,
                dodatno razviti jezičke vještine i vještinu prevođenja tekstova.
                Studenti će naročito unaprijediti jezičke vještine i tehnike:
                čitanja i razumijevanja teksta, slušanja i razumijevanja usmenog
                izlaganja, pisanja podnesaka i prevođenja. Takođe razviće
                vještine: sistematizacije, sumiranja i određivanja ključnih
                informacija iz teksta, diskusije i debatovanja na zadatu temu
                kao i rješavanje praktičnih problema koji se mogu javiti.
                Detaljnija i proširena znanja student će steći iz oblasti
                građanskog prava, poslovnog, radnog prava kao i oblasti
                međunarodnog prava.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Property law: Introduction: Course orientation; Legal
                terminology: Kinds of property; Ownership and Possession;
                Reading: Possessory Interests in the land; Grammar Revision:
                Narrative Tenses & Sequence of Tenses Tenses; Listening:
                Conveyance of Property; Grammar: Causative HAVE; Legal terms:
                Non-possessory interests and right; Word Building: Noun-forming
                suffixes; Problem solving: Landlord-Tenant; Writing: Letter to
                another lawyer; Project & Cases study: Lease & Eviction;
                Easement (Exploring legal provisions). Intellectual property
                law: Legal Terms: Basic concepts terminology and areas of IP;
                Listening: Barbie’s Story; Revision: Participles; Grammar:
                Participles and Participial Clauses; Reading: Copyright Law;
                Case Study: Fair Use Doctrine; Listening: Trademark; Labels and
                Brands; Exploring legal provisions; Case
                Study/Problem-solving/Project: Cyberlaw (Morris) Preparing a
                legal brief and written/oral arguments. Contract law 1: Legal
                terminology and Definitions: Basic contract terms; Types of
                contracts; Listening: Contract formation (note taking and
                summarizing); Elements of contract; Reading: Classification of
                contracts; Lg. functions: Offering Accepting Refusing; Word
                building: Verb-forming Suffixes. Contract law 2: Legal document:
                Contract of Sales (sample) Terms of contract Contract clause;
                Lg. focus: Language of Contracts: Compounds (here/there)
                Collocations; Grammar: Sentence word order and Negative
                Inversion; Word Building: Breach of Contract & Legal Remedies;
                Case study/Problem solving: Letter of Complaint Letter of
                Demand; Project work: Exploring sample contracts; translation;
                drafting contracts.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Property law: Introduction: Course orientation; Legal
                      terminology: Kinds of property; Ownership and Possession;
                      Reading: Possessory Interests in the land; Grammar
                      Revision: Narrative Tenses & Sequence of Tenses Tenses;
                      Listening: Conveyance of Property; Grammar: Causative
                      HAVE; Legal terms: Non-possessory interests and right;
                      Word Building: Noun-forming suffixes; Problem solving:
                      Landlord-Tenant; Writing: Letter to another lawyer;
                      Project & Cases study: Lease & Eviction; Easement
                      (Exploring legal provisions)
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Intellectual property law: Legal Terms: Basic concepts
                      terminology and areas of IP; Listening: Barbie’s Story;
                      Revision: Participles; Grammar: Participles and
                      Participial Clauses; Reading: Copyright Law; Case Study:
                      Fair Use Doctrine; Listening: Trademark; Labels and
                      Brands; Exploring legal provisions; Case
                      Study/Problem-solving/Project: Cyberlaw (Morris) Preparing
                      a legal brief and written/oral arguments
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Contract law 1: Legal terminology and Definitions: Basic
                      contract terms; Types of contracts; Listening: Contract
                      formation (note taking and summarizing); Elements of
                      contract; Reading: Classification of contracts; Lg.
                      functions: Offering Accepting Refusing; Word building:
                      Verb-forming Suffixes
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Contract law 2: Legal document: Contract of Sales (sample)
                      Terms of contract Contract clause; Lg. focus: Language of
                      Contracts: Compounds (here/there) Collocations; Grammar:
                      Sentence word order and Negative Inversion; Word Building:
                      Breach of Contract & Legal Remedies; Case study/Problem
                      solving: Letter of Complaint Letter of Demand; Project
                      work: Exploring sample contracts; translation; drafting
                      contracts
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Abour & employment law 1: Speaking/Vocabulary: Job
                      Opportunities Basic employment terminology; Listening:
                      Describing jobs workplaces and responsibilities; Reading:
                      Job Advertisements for Legal Positions; Learner skills:
                      Applying for A Job; Writing: Biography CV Forms; Writing:
                      A Cover Letter of Application; Listening: Job Interviews;
                      Learner skills: Interview Strategies
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Abour & employment law 2: Role-play: Job Interview; Legal
                      documents: Employment Contract; terms of employment;
                      employment law terms; Lg. focus: Termination of employment
                      (collocations); Word Building: Safety at work; Grammar:
                      The Infinitive vs the Gerund (Active and Passive Forms);
                      Case study/problem solving: Employment Discrimination
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>
                      The law of business commerce trade and finance 1: Speaking
                      & Vocabulary: business entities activities operations
                      environment; Listening: Types of businesses; Lg. focus:
                      Common Abbreviations Collocations; Reading: Law company
                      profile; Project: Making a business plan; Project
                      Presentation; Lg. Focus: Idiomatic expressions in Business
                      English
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      The law of business commerce trade and finance 2:
                      Vocabulary: Business/Trade law areas; business terms
                      financial institutions/instruments; Learner skills:
                      Professional Presentation; Describing a Product; Lg.
                      function: Describing a graph Describing Business trends
                      results and performance; Grammar: Revision of future
                      forms; The Future Perfect; Case study/problem solving:
                      Case analysis & Applying the law
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>
                      Dispute resolution 1: Definitions: Dispute Resolution:
                      Litigation Arbitration Negotiation Mediation; Lg.
                      Function: Comparing and Contrasting; Reading: Arbitration;
                      Case study: Arbitration; Learner skills: Negotiation
                      style; Lg. functions: Success in Negotiations
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>
                      Dispute resolution 2: Case study/problem solving: Toyota
                      Nissan; Grammar: Wishful Thinking; Listening: Litigation
                      vs Mediation; Learner skills: Mediation Process; Case
                      study & Simulation: Negotiation /Mediation Case; Case
                      study: Class action lawsuit
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      International Law: Legal terms: International law;
                      Reading: Sources and areas of law; Lg. focus:
                      Collocations; Word building: Prefixes; Listening:
                      International organizations and institutions; Writing:
                      Expository Essay; Case study/Problem solving: The Rainbow
                      Warrior; Case study/Understanding court decision:
                      International Abduction
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>
                      EU Law 1: Reading; EU Treaties (significance); Exploring
                      the Chart: EU structure and Policies; Vocabulary: EU
                      values; Speaking/Reading: EU Institutions; Word building:
                      Suffixes; Lg focus: statement verbs in EU documents;
                      Definitions: Legal Instruments; Vocabulary: Collocations
                      (EU decision-making processes); WB: EU law principles
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      EU Law 2: Vocabulary: Human Rights Policy; Case study:
                      ECHR ECJ cases and decisions; Listening: Lecture on EU
                      integration and EU membership (note taking summarizing);
                      Exploring Legal documents (directives resolutions
                      regulations) & Presentation task; Writing: Applying for
                      international projects/courses Writing a bio and
                      Motivation letter
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3 h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 1.35 h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3 h</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EngleskiJezik2;
